var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Minus-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-percentage",
    "data-name": "Icon awesome-percentage",
    d: "M4.267,8.768a2.5,2.5,0,1,0-3.536,0A2.5,2.5,0,0,0,4.267,8.768Zm10,6.465a2.5,2.5,0,1,0,0,3.536A2.5,2.5,0,0,0,14.267,15.232Zm-.076-9.04-.884-.884a1.25,1.25,0,0,0-1.768,0L.808,16.041a1.25,1.25,0,0,0,0,1.768l.884.884a1.25,1.25,0,0,0,1.768,0L14.192,7.959A1.25,1.25,0,0,0,14.192,6.192Z",
    transform: "translate(0 -4.5)",
    fill: "#fa2d2d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusIcon);
export default __webpack_public_path__ + "static/media/Minus-icon.97962aa2bb705d5d0191a1c9390743f7.svg";
export { ForwardRef as ReactComponent };